import { render, staticRenderFns } from "./PShopCard.vue?vue&type=template&id=68d95276&"
import script from "./PShopCard.vue?vue&type=script&lang=js&"
export * from "./PShopCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports